import { Paper, Stack, Typography } from '@mui/material';
import { Answer, OpenQuestion, Perspectives } from 'features/lead/lead-questionnaire/lead-questionnaire.types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import QuestionItem from './question-item';

interface Props {
  perspective?: Perspectives;
  openQuestions: OpenQuestion[];
  answers: Answer[];

  handleOpenTextFieldChange(id: string): (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const OpenQuestionsContainer: React.FC<Props> = ({ perspective, openQuestions, answers, handleOpenTextFieldChange }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Stack gap={4}>
      <Typography className={classes.title}>{t('leadQuestionnaireOpenQuestions')}</Typography>
      <Stack gap={1}>
        {perspective === Perspectives.SELF ? (
          <>
            <Typography className={classes.description}>{t('leadQuestionnaireOpenQuestionsSelfPerspectiveText1')}</Typography>
            <Typography className={classes.description}>{t('leadQuestionnaireOpenQuestionsSelfPerspectiveText2')}</Typography>
            <Typography className={classes.description}>{t('leadQuestionnaireOpenQuestionsSelfPerspectiveText3')}</Typography>
          </>
        ) : (
          <>
            <Typography className={classes.description}>{t('leadQuestionnaireOpenQuestionsOtherPerspectiveText1')}</Typography>
            <Typography className={classes.description}>{t('leadQuestionnaireOpenQuestionsOtherPerspectiveText2')}</Typography>
            <Typography className={classes.description}>{t('leadQuestionnaireOpenQuestionsOtherPerspectiveText3')}</Typography>
          </>
        )}
        <Typography className={classes.description}>{t('leadQuestionnaireOpenQuestionsThankYou')}</Typography>
      </Stack>
      <Stack gap={2}>
        {openQuestions.map((question, index, questions) => (
          <Paper key={question.id} className={classes.textContainer} elevation={2} square={true}>
            <div className={classes.header}>
              <Typography className={classes.categoryName}>
                {perspective === Perspectives.SELF ? question.selfAssessment : question.externalAssessment}
              </Typography>
            </div>
            <QuestionItem
              perspective={perspective}
              question={question}
              index={index}
              questions={questions}
              questionType={'open'}
              answers={answers}
              handleOpenTextFieldChange={handleOpenTextFieldChange}
            />
          </Paper>
        ))}
      </Stack>
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  title: {
    fontSize: theme.typography.pxToRem(32),
    textAlign: 'center',
    fontWeight: 'bold',
  },
  description: {
    fontSize: theme.typography.pxToRem(18),
    color: theme.palette.greys.medium,
    padding: '0 16px',
  },
  textContainer: {
    background: 'rgba(0,0,0,0.03)',
  },
  header: {
    backgroundColor: theme.palette.primary.main,
    color: '#FFF',
    padding: '8px 48px 8px 16px',
    minHeight: '60px',
    display: 'flex',
    alignItems: 'center',
  },
  categoryName: {
    fontSize: theme.typography.pxToRem(20),
  },
}));

export default OpenQuestionsContainer;
